module.exports = __webpack_public_path__ + "media/images/exp-four-7bb67f443f13ac82b7fc6be25e243cd8.png";